import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResponseApi, ResponseListApi } from '@core/models/interfaces/common';
import {
  PolicyStatusCreate,
  PolicyStatusDetails,
  PolicyStatusGetParams,
  PolicyStatusStatistics
} from '@core/models/interfaces/lead/lead-policy-status';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PolicyStatusService {
  baseUrl = `${environment.API_URL}/crm/policy-status`;

  constructor(private http: HttpClient) {}

  getPagePolicyStatus(params?: PolicyStatusGetParams) {
    let queryParams = new HttpParams();

    if (params?.keyword !== undefined) {
      queryParams = queryParams = queryParams.append('keyword', params.keyword);
    }

    if (params?.parentId !== undefined) {
      queryParams = queryParams = queryParams.append('parentId', params.parentId);
    }

    if (params?.page !== undefined) {
      queryParams = queryParams = queryParams.append('page', params.page);
    }

    if (params?.size !== undefined) {
      queryParams = queryParams = queryParams.append('size', params.size);
    }

    if (params?.sorts !== undefined) {
      queryParams = queryParams = queryParams.append('sorts', params.sorts);
    }

    return this.http.get<ResponseListApi<PolicyStatusDetails>>(this.baseUrl, {
      params: queryParams
    });
  }

  createPolicyStatus(body: PolicyStatusCreate) {
    return this.http.post<ResponseApi<PolicyStatusDetails>>(this.baseUrl, body);
  }

  deletePolicyStatus(id: string) {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }

  updateCompany(id: string, body: PolicyStatusCreate) {
    return this.http.put<ResponseApi<PolicyStatusDetails>>(`${this.baseUrl}/${id}`, body);
  }

  getCompanyById(id: string) {
    return this.http.get<ResponseApi<PolicyStatusDetails>>(`${this.baseUrl}/${id}`);
  }

  getPolicyStatusStatistics() {
    return this.http.get<ResponseApi<PolicyStatusStatistics[]>>(`${this.baseUrl}/statistics`);
  }
}
